import { TJobs } from "@/modules/job-board/types";

export const APP_NAME = "PropTechBuzz";

export const GFORM_LINK = "https://forms.gle/KEqBT6VxQ1AgbTNz5";

export const PRODUCTION_HOSTNAME = "www.proptechbuzz.com";
export const PRODUCTION_BASE_URL = "https://www.proptechbuzz.com";

export const CMS_URL = process.env.NEXT_PUBLIC_CMS_URL;
export const CMS_TOKEN = process.env.NEXT_PUBLIC_CMS_TOKEN;

export const { GOOGLE_GEOCODING_API_URL } = process.env;
export const { GOOGLE_MAPS_API_KEY } = process.env;

export const BASE_URL =
	typeof window !== "undefined"
		? window.location.origin
		: process.env.NEXT_PUBLIC_BASE_URL ||
		  (process.env.VERCEL_URL && `https://${process.env.VERCEL_URL}`) ||
		  "http://localhost:3000";

export const CALLBACK_URL = BASE_URL;

export const MOBILE_APP_VERSIONS = [
	{
		version: "1.0.0",
		releaseDate: "2024-07-12",
		current: true,
		forceUpdate: false,
		forceLogout: false,
	},
];

export const { GOOGLE_TAG_MANAGER_ID } = process.env;

export const STATIC_LINKS = {
	iOSAppStoreURL: "https://apps.apple.com/in/app/proptechbuzz/id6504497268",
	androidPlayStoreURL: "https://play.google.com/store/apps/details?id=com.proptechbuzz.app",
};

export const LOGO_PLACEHOLDER_IMAGE_PATH = `/images/default-placeholder-image.png`;
export const LOGO_PLACEHOLDER_IMAGE_URL = `${BASE_URL}${LOGO_PLACEHOLDER_IMAGE_PATH}`;

export const INTERNAL_TESTER_EMAILS = [
	"proptechbuzztest@proton.me",
	"apple@proton.me",
	"android@proton.me",
];

export const PTB_HOMEPAGE_FEATURED_VIDEO = {
	// TODO: Replace this process.env with a variable
	thumbnailUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/thumbnail.jpg`,
	thumbnailAlt: "Proptech Showcase Disrupt",
	videoUrl: "https://www.youtube-nocookie.com/embed/gOizlvGi97w?autoplay=1&start=0&mute=1",
	videoTitle:
		"Proptech Showcase Disrupt - How to Navigate Real Estate Licensing and Build Seamless Home Search Experiences",
	text: "Proptech Showcase Disrupt - How to Navigate Real Estate Licensing and Build Seamless Home Search Experiences",
};

export const {
	HARDCODED_OTP,
	HARDCODED_OTP_ASSOCIATED_EVENT_SLUG,
	HARDCODED_OTP_ASSOCIATED_COMMUNITY_SLUG,
} = process.env;

export const PRODUCT_FORM = `${BASE_URL}/products/form/getting-started`;

export const SIGNIN_API = `${BASE_URL}/api/signin`;
export const VALIDATE_SIGNUP_API = `${BASE_URL}/api/signup/validate`;
export const SIGNUP_API = `${BASE_URL}/api/signup`;
export const PRODUCTS_API = `${BASE_URL}/api/products`;
export const TAGS_API = `${BASE_URL}/api/tags`;
export const TAGS_LISTING_API = `${BASE_URL}/api/tags/listing`;
export const CATEGORIES_API = `${BASE_URL}/api/categories`;
export const REGIONS_API = `${BASE_URL}/api/regions`;
export const VOTES_API = `${BASE_URL}/api/votes`;
export const PRODUCT_VOTES_API = `${BASE_URL}/api/votes/productv2-vote`;
export const COMMENTS_API = `${BASE_URL}/api/comments`;
export const PRODUCT_DETAILS_API = `${BASE_URL}/api/products/details`;
export const STATS_API = `${BASE_URL}/api/stats`;
export const PRODUCT_ALL_DETAILS_API = `${BASE_URL}/api/products/details-all`; // used to fetch product details during edit
export const NEWSLETTER_API = `${BASE_URL}/api/newsletter`;
export const FEEDBACK_API = `${BASE_URL}/api/feedback`;
export const PRODUCT_IDEA_API = `${BASE_URL}/api/product-idea`;
export const CONTACT_US_API = `${BASE_URL}/api/contact-us`;
export const PR_SOLUTIONS_API = `${BASE_URL}/api/press-form`;
export const TICKET_PURCHASE_API = `${BASE_URL}/api/ticket-purchase`;
export const CONTACT_US_MARKETING_API = `${BASE_URL}/api/contact-us-marketing`;
export const CATEGORIES_LISTING_API = `${BASE_URL}/api/categories/listing`;
export const TRENDING_NEWS_API = `${BASE_URL}/api/trending-news`;
export const GLOBAL_SEARCH_API = `${BASE_URL}/api/search`;
export const CATEGORY_LEADERS_API = `${BASE_URL}/api/categories/leaders`;

export const FAMILIES_API = `${BASE_URL}/api/families`;
export const FAMILIES_LISTING_API = `${BASE_URL}/api/families/listing`;
export const LISTING_API = `${BASE_URL}/api/listing`;

export const USER_PROFILE_API = `${BASE_URL}/api/profile`;
export const CONNECTIONS_API = `${BASE_URL}/api/connections`;
export const PRODUCT_NAME_CHECK = `${BASE_URL}/api/products/name-check`;
export const USER_TYPES_API = `${BASE_URL}/api/user-types`;

export const USERS_SUGGESTIONS_API = `${BASE_URL}/api/users/suggestions`;

// Company
export const COMPANIES_SEARCH_API = `${BASE_URL}/api/companies/search`;

// Leaderboard APIs
export const LEADERBOARD_API = `${BASE_URL}/api/leaderboard`;
export const LEADERBOARD_SEARCH_API = `${BASE_URL}/api/leaderboard/search`;
export const LEADERBOARD_USERS_API = `${BASE_URL}/api/leaderboard/users`;

// Discussion Board APIs
export const CHANNELS_API = `${BASE_URL}/api/channels`;
export const CHANNEL_MEMBERS_API = `${BASE_URL}/api/channels/members`;
export const DISCUSSIONS_API = `${BASE_URL}/api/discussions`;
export const TRENDING_DISCUSSIONS_API = `${BASE_URL}/api/discussions/trending`;
export const DISCUSSIONS_INTERACTIONS_API = `${BASE_URL}/api/discussions/interactions`;
export const DISCUSSIONS_SEARCH_API = `${BASE_URL}/api/discussions/search`;

// Public ticket info
export const ALL_TICKET_INFO_API = `${BASE_URL}/api/ticket-info`;

// Private Discussion Board APIs
export const PRIVATE_DISCUSSION_BOARD_CHANNELS_API = `${BASE_URL}/api/channels/private`;
export const PRIVATE_DISCUSSIONS_API = `${BASE_URL}/api/discussions/private`;

export const PRIVATE_COMMUNITIES_API = `${BASE_URL}/api/communities`;

// Online Users
export const ONLINE_USERS_API = `${BASE_URL}/api/users/online`;

// Messaging
export const CHATS_API_BASE_URL = `${BASE_URL}/api/chats`;
export const CHAT_INBOX_API = `${CHATS_API_BASE_URL}/inbox`;
export const GROUP_CHAT_API = `${CHATS_API_BASE_URL}/group`;
export const CHAT_DIRECT_MESSAGING_API = `${CHATS_API_BASE_URL}/direct`;
export const INBOX_ONLINE_USERS_API = `${CHATS_API_BASE_URL}/online`;

// Discussion Page URL and Path
export const DISCUSSION_BOARD_URL = `${BASE_URL}/forums`;
export const DISCUSSION_BOARD_PATH = `/forums`;

// Media portal URL and Path
export const NEWS_PORTAL_URL = `${BASE_URL}/news`;
export const NEWS_PORTAL_PATH = `/news`;
export const BLOG_URL = `${BASE_URL}/blog`;
export const BLOG_PATH = `/blog`;

// Private discussion boards
export const PRIVATE_DISCUSSION_BOARD_URL = `${BASE_URL}/communities`;
export const PRIVATE_DISCUSSION_BOARD_PATH = `/communities`;

// Avatar API
export const AVATAR_API = `https://xtb-avatar-generator-api.up.railway.app/8.x`;

// Common APIs for default and private discussion boards
export const CHANNELS_SEARCH_API = `${BASE_URL}/api/channels/search`;

export const CHANNEL_REQUESTS_API = `${BASE_URL}/api/channels/requests`;

export const NO_REPLY_EMAIL = "no-reply@proptechbuzz.com";

// MEDIA PORTS API
export const MEDIA_API_BASE_URL = "https://media.proptechbuzz.com/wp-json/wp/v2";

// TAGS SEARCH API
export const TAGS_SEARCH_API = `${BASE_URL}/api/tags/search`;

// INTEGRATION TAGS SEARCH API
export const INTEGRATION_TAGS_SEARCH_API = `${BASE_URL}/api/integration-tags/search`;

// PRODUCT SUBMISSION CITIES BY COUNTRY ISO API
export const PRODUCT_SUBMISSION_CITIES_API = `${BASE_URL}/api/product-submission/cities`;

// PRODUCT SUBMISSION PLACES API (GOOGLE MAPS)
export const PRODUCT_SUBMISSION_PLACES_API = `${BASE_URL}/api/common/places`;

// PRODUCT SUBMISSION VALIDATE WEBSITE URL API
export const PRODUCT_SUBMISSION_VALIDATE_WEBSITE_API = `${BASE_URL}/api/product-submission/validate-website-url`;

export const COMPANIES_API = `${BASE_URL}/api/companies`;

export const PRODUCTS_V2_API = `${BASE_URL}/api/products/v2/`;

export const ADVANCED_SEARCH_API = `${BASE_URL}/api/search/advanced`;

// Schedule Call API
export const SCHEDULE_CALL_API = `${BASE_URL}/api/schedule-call`;

// Country Portal API
export const COUNTRY_PORTAL_PRODUCTS_V2_API = `${BASE_URL}/api/search/advanced`;

// Rules
// TODO: Remove these rules and use the rules from the database

export const FORUM_RULES = {
	VIP_ONLY: "vip_only",
	VERIFIED_ONLY: "verified_only",
	APPROVAL_ONLY: "approval_only",
};

export const TYPES_OF_CHANNELS = {
	PREJOIN: "prejoin",
	INCOGNITO: "incognito",
};

export const CHAT_RULES = {
	VIP_ONLY: "vip_only",
	VERIFIED_ONLY: "verified_only",
};

// New Community Constants
export const ROLE_HIERARCHY: Record<string, string[]> = {
	GUEST: ["GUEST"],
	UNVERIFIED_USER: ["UNVERIFIED_USER"],
	VERIFIED_USER: ["VERIFIED_USER", "UNVERIFIED_USER"],
	VERIFIED_VIP: ["VERIFIED_USER", "VERIFIED_VIP", "UNVERIFIED_USER"],
	COMMUNITY_MEMBER: ["COMMUNITY_MEMBER", "VERIFIED_USER", "UNVERIFIED_USER"],
	COMMUNITY_MODERATOR: ["COMMUNITY_MEMBER", "COMMUNITY_MODERATOR", "UNVERIFIED_USER"],
};

export const USER_ROLES = {
	VERIFIED_USER: "VERIFIED_USER",
	VERIFIED_VIP: "VERIFIED_VIP",
	UNVERIFIED_USER: "UNVERIFIED_USER",
};

export const COMMUNITY_MEMBER_ROLES = {
	COMMUNITY_MODERATOR: "COMMUNITY_MODERATOR",
	COMMUNITY_MEMBER: "COMMUNITY_MEMBER",
	CHANNEL_MODERATOR: "CHANNEL_MODERATOR",
};

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
	[USER_ROLES.VERIFIED_USER]: "Verified Users",
	[USER_ROLES.VERIFIED_VIP]: "Verified VIPs",
	[USER_ROLES.UNVERIFIED_USER]: "Unverified Users",
	[COMMUNITY_MEMBER_ROLES.COMMUNITY_MODERATOR]: "Community Moderators",
	[COMMUNITY_MEMBER_ROLES.COMMUNITY_MEMBER]: "Community Members",
	[COMMUNITY_MEMBER_ROLES.CHANNEL_MODERATOR]: "Channel Moderators",
};

export const ASSETS_BASE_PREFIX = process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX!;

export const emailServerConfig = {
	host: process.env.EMAIL_SERVICE_HOST,
	port: parseInt(process.env.EMAIL_SERVICE_PORT || "587"),
	auth: {
		user: process.env.EMAIL_SERVICE_USERNAME,
		pass: process.env.EMAIL_SERVICE_PASSWORD,
	},
};

export const fromEmail = "no-reply@alerts.proptechbuzz.com";
export const emailValidity = 10 * 60; // 10 minutes

export const PRODUCT_IDEA_FROM_EMAIL = "contact@alerts.proptechbuzz.com";
export const PRODUCT_IDEA_TO_EMAIL = "marketing@proptechbuzz.com";

export const CONTACT_FROM_EMAIL = "contact@alerts.proptechbuzz.com";
export const CONTACT_TO_EMAIL = "marketing_alerts@proptechbuzz.com";

// File Validation
export const MAX_IMAGE_FILE_SIZE = 5000000;
export const ACCEPTED_IMAGE_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const ACCEPTED_DOCUMENT_FILE_TYPES = ["application/pdf"];
export const MAX_DOCUMENT_FILE_SIZE = 25000000;

// S3 Media paths
export const RICH_TEXT_MEDIA_PATH = "rich-text-media/uploads";
export const DRAFT_RICH_TEXT_MEDIA_PATH = "drafts/rich-text-media/uploads";

// Country Portal
export const INDIA_COUNTRY_PORTAL = {
	community_slug: "proptech-india",
};

export const countryISOs = {
	Afghanistan: "AF",
	Albania: "AL",
	Algeria: "DZ",
	Andorra: "AD",
	Angola: "AO",
	"Antigua and Barbuda": "AG",
	Argentina: "AR",
	Armenia: "AM",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bhutan: "BT",
	Bolivia: "BO",
	"Bosnia and Herzegovina": "BA",
	Botswana: "BW",
	Brazil: "BR",
	Brunei: "BN",
	Bulgaria: "BG",
	"Burkina Faso": "BF",
	Burundi: "BI",
	"Cabo Verde": "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	"Central African Republic": "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	Colombia: "CO",
	Comoros: "KM",
	"Congo, Democratic Republic of the": "CD",
	"Congo, Republic of the": "CG",
	"Costa Rica": "CR",
	"Cote d'Ivoire": "CI",
	Croatia: "HR",
	Cuba: "CU",
	Cyprus: "CY",
	Czechia: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	"Dominican Republic": "DO",
	Ecuador: "EC",
	Egypt: "EG",
	"El Salvador": "SV",
	"Equatorial Guinea": "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Greece: "GR",
	Grenada: "GD",
	Guatemala: "GT",
	Guinea: "GN",
	"Guinea-Bissau": "GW",
	Guyana: "GY",
	Haiti: "HT",
	Honduras: "HN",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	"Korea, North": "KP",
	"Korea, South": "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	"Marshall Islands": "MH",
	Mauritania: "MR",
	Mauritius: "MU",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	"New Zealand": "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	"North Macedonia": "MK",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	"Papua New Guinea": "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Poland: "PL",
	Portugal: "PT",
	Qatar: "QA",
	Romania: "RO",
	Russia: "RU",
	Rwanda: "RW",
	"Saint Kitts and Nevis": "KN",
	"Saint Lucia": "LC",
	"Saint Vincent and the Grenadines": "VC",
	Samoa: "WS",
	"San Marino": "SM",
	"Sao Tome and Principe": "ST",
	"Saudi Arabia": "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	"Sierra Leone": "SL",
	Singapore: "SG",
	Slovakia: "SK",
	Slovenia: "SI",
	"Solomon Islands": "SB",
	Somalia: "SO",
	"South Africa": "ZA",
	"South Sudan": "SS",
	Spain: "ES",
	"Sri Lanka": "LK",
	Sudan: "SD",
	Suriname: "SR",
	Sweden: "SE",
	Switzerland: "CH",
	Syria: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	"Timor-Leste": "TL",
	Togo: "TG",
	Tonga: "TO",
	"Trinidad and Tobago": "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	"United Arab Emirates": "AE",
	"United Kingdom": "GB",
	"United States": "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	"Vatican City": "VA",
	Venezuela: "VE",
	Vietnam: "VN",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW",
};

export const JOBS_LISTING: TJobs[] = [
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/accacia.png",
		title: "Head of Growth",
		location: "Bangalore - India, Singapore",
		duration: "Full Time",
		company: "Accacia",
		isRemote: false,
		applyLink:
			"https://dynamic-polka-cd9.notion.site/Careers-07495d488c8e4af5a07d40709f6dadbf?p=e8e0200f29c242d4be70d1f772e99290&pm=c",
		lastUpdated: "2 days ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/nomadstays.jpeg",
		title: "Marketing Intern",
		location: "",
		duration: "Full Time",
		company: "Nomad Stays",
		isRemote: false,
		applyLink: "https://www.nomadstays.com/jobs",
		lastUpdated: "2 days ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/housewise.png",
		title: "Operations Associate",
		location:
			"Thane / Palghar / Navi Mumbai / Mumbai / Pune / Goa / Hyderabad / Bangalore / Chennai / Delhi-NCR",
		duration: "Full Time",
		company: "Housewise",
		isRemote: false,
		applyLink: "https://housewise.in/careers-with-housewise",
		lastUpdated: "1 day ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/anacity.png",
		title: "Business Lead- Residential Services",
		location: "Mumbai, India",
		duration: "Full Time",
		company: "Anarock",
		isRemote: false,
		applyLink:
			"https://websitemedia.anarock.com/media/Business_Lead_Residential_Services_d2018697d1.pdf",
		lastUpdated: "1 day ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/housemonk.png",
		title: "Enterprise Sales Executive",
		location: "Bangalore, India",
		duration: "Full Time",
		company: "Housemonk",
		isRemote: false,
		applyLink: "https://www.linkedin.com/jobs/view/3656594970",
		lastUpdated: "1 day ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/housewise.png",
		title: "Operations Manager (Female only)",
		location: "WFH",
		duration: "Full Time",
		company: "Housewise",
		isRemote: true,
		applyLink: "https://housewise.in/careers-with-housewise",
		lastUpdated: "1 day ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/zapkey.png",
		title: "Closing Manager",
		location: "Central part of Mumbai",
		duration: "Full Time",
		company: "Zapkey",
		isRemote: false,
		applyLink:
			"https://www.linkedin.com/posts/mohd-sajid-204a48119_closing-central-ghatkopar-activity-7084208781902905344-X34U",
		lastUpdated: "1 day ago",
	},
	{
		logo: "https://proptechbuzz-dev.s3.amazonaws.com/others-job-board/matrixian.png",
		title: "Content Marketer",
		location: "Amsterdam",
		duration: "Full Time",
		company: "Matrixian Group",
		isRemote: false,
		applyLink: "https://careers.matrixiangroup.com/content-marketeer-3",
		lastUpdated: "1 day ago",
	},
];

export const LATAM_COUNTRIES = [
	"Argentina",
	"Bolivia",
	"Brazil",
	"Chile",
	"Colombia",
	"Costa Rica",
	"Cuba",
	"Dominican Republic",
	"Ecuador",
	"El Salvador",
	"Guatemala",
	"Honduras",
	"Mexico",
	"Nicaragua",
	"Panama",
	"Paraguay",
	"Peru",
	"Puerto Rico",
	"Uruguay",
	"Venezuela",
];
